import axios from 'axios';

const platformApi = axios.create({
  baseURL: '/api/platform',
  headers: { 'Content-Type': 'application/json' },
});

platformApi.interceptors.request.use(config => {
  const token = localStorage.getItem('platform_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

platformApi.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('platform_token');
      localStorage.removeItem('platform_tenant');
      window.location.href = '/platform/login';
    }
    return Promise.reject(error);
  }
);

export const platformAPI = {
  // Onboarding
  signup: (data) => platformApi.post('/onboarding/signup', data),
  login: (data) => platformApi.post('/onboarding/login', data),
  getApplication: () => platformApi.get('/onboarding/application'),
  updateApplication: (data) => platformApi.put('/onboarding/application', data),
  uploadDocument: (docType, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return platformApi.post(`/onboarding/documents/${docType}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  submitApplication: () => platformApi.post('/onboarding/submit'),

  // Dashboard (JWT-authenticated)
  getDashboardStats: () => platformApi.get('/dashboard/stats'),
  getWallets: (params = {}) => platformApi.get('/dashboard/wallets', { params }),
  getWalletDetail: (walletId) => platformApi.get(`/dashboard/wallets/${walletId}`),
  createWalletFromDashboard: (data) => platformApi.post('/dashboard/wallets/create', data),
  activateVA: (walletId, bvn) => platformApi.post(`/dashboard/wallets/${walletId}/activate-va`, bvn ? { bvn } : {}),
  bulkActivateVA: () => platformApi.post('/dashboard/wallets/bulk-activate-va'),
  getTransactions: (params = {}) => platformApi.get('/dashboard/transactions', { params }),
  getWebhookEvents: (params = {}) => platformApi.get('/dashboard/webhook-events', { params }),
};

export { platformApi };
export default platformApi;
